export default "__VITE_ASSET__CZK5bLNQ__"